var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "questionRender" }, [
    _c(
      "div",
      { staticClass: "operation_title" },
      [
        _c("div", { staticClass: "tips" }, [
          _vm._v(_vm._s(_vm.questionType[_vm.question.questionTypeId]))
        ]),
        _vm._v(" "),
        _vm.question.questionTypeId == 9 && _vm.show
          ? _c(
              "div",
              {
                staticClass: "zl_button zl_whiteButton",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.handleGoStudy(_vm.question)
                  }
                }
              },
              [_vm._v("\n        去实操\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        [
          _vm.isShowMore
            ? _c(
                "span",
                {
                  staticClass: "noshowbtn",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.isShowMore = false
                    }
                  }
                },
                [_vm._v("收起")]
              )
            : _c(
                "span",
                {
                  staticClass: "noshowbtn",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.clickShowMore.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("展开")]
              )
        ]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ],
        staticClass: "renderCont",
        class: { isShowMore: _vm.isShowMore }
      },
      [
        _c("div", {
          staticClass: "editorShowArea ql-editor",
          staticStyle: { height: "calc(100% + 24px)" },
          domProps: { innerHTML: _vm._s(_vm.question.questionContent) }
        }),
        _vm._v(" "),
        _vm.question.questionTypeId < 9
          ? _c(
              "div",
              { staticStyle: { padding: "10px 70px" } },
              [
                _vm.content && _vm.content.length
                  ? [
                      _vm.question.questionTypeId == 1
                        ? _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.answer,
                                callback: function($$v) {
                                  _vm.answer = $$v
                                },
                                expression: "answer"
                              }
                            },
                            _vm._l(_vm.content, function(item, index) {
                              return _c(
                                "p",
                                {
                                  key: index,
                                  staticStyle: { padding: "5px 0" }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    { attrs: { label: item.itemKey } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.itemKey +
                                            "、" +
                                            _vm.filterC(item.itemValue)
                                        ) + "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm.question.questionTypeId == 2
                        ? _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.answer,
                                callback: function($$v) {
                                  _vm.answer = $$v
                                },
                                expression: "answer"
                              }
                            },
                            _vm._l(_vm.content, function(item, index) {
                              return _c(
                                "p",
                                {
                                  key: index,
                                  staticStyle: { padding: "5px 0" }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    { attrs: { label: item.itemKey } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.itemKey +
                                            "、" +
                                            _vm.filterC(item.itemValue)
                                        ) + "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                [
                  _vm.question.questionTypeId == 3
                    ? _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.answer,
                            callback: function($$v) {
                              _vm.answer = $$v
                            },
                            expression: "answer"
                          }
                        },
                        [
                          _c(
                            "p",
                            { staticStyle: { padding: "5px 0" } },
                            [
                              _c("el-radio", { attrs: { label: "正确" } }, [
                                _c("i", { staticClass: "el-icon-check" })
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticStyle: { padding: "5px 0" } },
                            [
                              _c("el-radio", { attrs: { label: "错误" } }, [
                                _c("i", { staticClass: "el-icon-close" })
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.show && _vm.question.questionTypeId < 9
          ? _c("div", { staticClass: "answer_sec" }, [
              _vm.isShowAnswer
                ? _c("div", { staticClass: "official_answer" }, [
                    _c("p", [
                      _c("strong", [_vm._v("作答结果：")]),
                      _vm._v(" "),
                      _vm.answer_res
                        ? _c("span", { staticStyle: { color: "#67C23A" } }, [
                            _vm._v("正确")
                          ])
                        : _c("span", { staticStyle: { color: "#F56C6C" } }, [
                            _vm._v("错误")
                          ])
                    ]),
                    _vm._v(" "),
                    !_vm.answer_res && _vm.questionAnalysis
                      ? _c("p", {
                          domProps: { innerHTML: _vm._s(_vm.questionAnalysis) }
                        })
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "zl_button zl_blueButton",
                  on: {
                    click: function($event) {
                      return _vm.saveAnswer(_vm.question)
                    }
                  }
                },
                [_vm._v("保存答案")]
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-185ba388", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185ba388","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/questionRender.vue
// module id = null
// module chunks = 